var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/_html.js
// module id = 194
// module chunks = 0